import React, { useState, useCallback, useEffect } from "react";
import moment from "moment";
import { generatePath } from "react-router";
import { Route, Switch, Redirect } from "react-router-dom";
import { useTranslation } from 'react-i18next';
import { useStoreState, useStoreActions } from 'easy-peasy';


import { Row, Col } from "stories/layout";
import { Card, Typography, Button, Link, IconButton, BreadcrumbsDynamic } from "stories/components";
import { PageHeader } from "components/Page"
import PageTabs from "components/PageTabs/PageTabs"

import TransactionsList from "views/app/TransactionsList/TransactionsList"

const Example = () => {
  return (
    <>Example</>
  )
}

const TransactionsView = ({match, location}) => {
  const unmadeSplitTransactions = useStoreState((state) => state.unmadeSplitTransactions?.unmadeSplitTransactions);
  const { t } = useTranslation();
  const [exportButton, setExportButton] = useState(null);

  const getCrumbLinks = () => {
    const tail = { name: t("Ostot ja myynnit"), url: "/dashboard/transactions" };
    if (location?.state?.crumbLinks?.length) {
      return [...location.state.crumbLinks, tail];
    }
    return [
      { name: t("Etusivu"), url: "/dashboard/" },
      tail,
    ];
  };
  
  const tabs = [
    {
      key: "purchases",
      label: t("purchases_list_title", "Ostot ja myynnit"),
    },
    /*{
      key: "sales",
      label: t("sales_list_title", "Myynnit"),
    },
    {
      key: "dividends",
      label: t("dividends_list_title", "Osingot"),
    }
    */
  ]
  
  return (
    <>
    <div className="row align-items-start">
      <div className="col min-w-0">
        <PageHeader title={t("Ostot ja myynnit")} />
        <BreadcrumbsDynamic links={getCrumbLinks()} />
      </div>
      {exportButton ? (
        <div className="col-12 col-md-auto d-flex align-items-start justify-content-md-end flex-wrap mt-2 mt-md-0">
          {exportButton}
        </div>
      ) : null}
    </div>

      <TransactionsList productId={match?.params?.productId} setExportButton={setExportButton} />

      <Typography  variant="small" className="mt-5 text-gray">
      * {t("transactions_views_batch_original_balance","Erän alkuperäinen määrä on splitattu ja se noudattaa samaa suhdetta kuin mikä hyväksyttiin split-kirjauksen yhteydessä. Tietoa tarvitaan erilaisissa laskennoissa.")}
    </Typography>

    <Typography  variant="small" className="mt-2 text-gray">
      ** {t("transactions_views_batch_original_purchasedate","Vaihdetun erän alkuperäinen hankintapäivämäärä")}
    </Typography>
    </>
  )
  
  /*
  return (
    <>
      <PageTabs match={match} tabs={tabs} />
      
      <PageContainer className="page_container">
        <Switch>
          <Route
            path={
              generatePath(match.path, {
                tab: "purchases"
              })
            }
            exact
            render={props => <PurchasesList {...props} productId={match?.params?.productId} />}
          />
          <Route
            path={
              generatePath(match.path, {
                tab: "sales"
              })
            }
            exact
            render={props => <Example {...props} />}
          />
        </Switch>
      </PageContainer>


      
    </>
  );
  */
}

export default TransactionsView;
